import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import type { Article } from "@/mocks/articles";

interface Props {
  articles: Article[];
}

const colorMap = {
  primary: "bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50",
  accent: "bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50",
  secondary: "bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50",
};

export default function CategoryGrid({ articles }: Props) {
  const countOf = (slug: string) => articles.filter((a) => a.category === slug).length;

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center gap-3 mb-5 md:mb-7">
        <span className="bg-primary-500 w-1.5 h-7 rounded-full" />
        <div>
          <h4 className="text-lg md:text-xl font-bold text-foreground-950">资讯分类</h4>
          <p className="text-xs md:text-sm text-foreground-500 mt-1">快速进入你感兴趣的娱乐领域</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group flex flex-col items-center gap-2 md:gap-3 p-4 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors text-center animate-fade-up"
          >
            <span
              className={`w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center transition-colors ${colorMap[c.color as keyof typeof colorMap]}`}
            >
              <i className={`${c.icon} text-2xl md:text-3xl`} />
            </span>
            <span className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
              {c.name}
            </span>
            <span className="text-xs text-foreground-400">{countOf(c.slug)} 篇资讯</span>
          </Link>
        ))}
      </div>
    </section>
  );
}